import { useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styles from "./forgetPassword.module.css";
import { loginAPI } from "../loginAPI";

export const ForgetPassword = observer(({ setIsOpen }) => {
  const { t } = useTranslation("login");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value.trim();

    setIsSubmitting(true);
    try {
      await loginAPI.forgetPassword(email);
      setIsSent(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button
          className={styles.modalClose}
          disabled={isSubmitting}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          ×
        </button>
        <div className={isSent ? styles.successIconWrap : styles.iconWrap}>
          {isSent ? "✓" : "🔑"}
        </div>
        <h2 className={styles.title}>
          {isSent ? t("Successfully Sent.") : t("Reset your password")}
        </h2>
        <div className={styles.divider} />
        {isSent ? (
          <>
            <p className={styles.content}>
              {t(
                "If the email is registered, it will receive a mail with reset password instructions. Please check your inbox (including spam)."
              )}
            </p>
            <div className={styles.footerSep} />
          </>
        ) : (
          <>
            <p className={styles.content}>
              {t(
                "Please enter your registered email address below to start the process. If you need further assistance, please contact our customer service team."
              )}
            </p>
            <form className={styles.form} onSubmit={handleSubmit}>
              <label htmlFor="email">{t("Email")}</label>
              <input
                className={styles.emailInput}
                type="email"
                name="email"
                required
                disabled={isSubmitting}
                placeholder={t("Email")}
              />
              <div className={styles.footerSep} />
              <button
                type="submit"
                className={styles.submitBtn}
                disabled={isSubmitting}
              >
                {isSubmitting ? t("Sending...") : t("Send")}
              </button>
            </form>
          </>
        )}
        {isSent && (
          <button
            type="button"
            className={styles.submitBtn}
            onClick={() => setIsOpen(false)}
          >
            {t("Close")}
          </button>
        )}
      </div>
    </div>
  );
});
